export enum TextTemplatePurposeType {
  Sms = "Sms",
  Email = "Email",
  WhatsApp = "WhatsApp"
}
